<div *ngIf="showBanner" class="u-shadow-mini welcome-banner" style="min-height: 6em;">
	<div class="welcome-user">
		<span class="welcome-back-text">{{ welcomMsg }}</span>
	</div>
</div>
